import { call, put } from 'redux-saga/effects';

import { api, notify } from 'services';
import { IFechRequest } from 'interfaces/fetch-duck';
import { requestErrorHandler } from 'utils';
import { FetchScheduledOrderFOBActions } from 'store/ducks/ordersFob';

export function* fetchScheduledOrderFOBRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(api.get, `/orders-fob-scheduled/${id}`);

    yield put(FetchScheduledOrderFOBActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { onFailure } = action as IFechRequest;
    if (onFailure) onFailure();
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(FetchScheduledOrderFOBActions.failure(errorMessage));
  }
}
